module.exports = __webpack_public_path__ + "app/img/email-outline.30549dde.svg";